import HttpFactory from '@/mixins/http.factory';
import VueRecaptcha from 'vue-recaptcha';
import { Select, Option } from 'element-ui'
export default {
	name: 'pricing-quote',
	mixins:[HttpFactory],
	props:{
		demo: {
			type: Boolean,
			required: false,
			default: () => false
		},
		contact: {
			type: Boolean,
			required: false,
			default: () => false
		},
	},
	data () {
		return {
			data:null,
			showForm:false,
			showCaptcha:false,
			isCaptchaVerified:false
		}
	},
	created(){
		this.init();
	},

	methods:{
		init(){
			const _self=this;
			_self.resetForm();
		},
		onVefify(){
			const _self=this;
			_self.isCaptchaVerified=true;
		},
		onExpired(s){
			const _self=this;
			_self.resetForm();
		},
		onError(d){
			const _self=this;
			//_self.resetForm();
		},
		resetForm(){
			const _self=this;
			_self.data={appName:''};
			_self.isCaptchaVerified=false;
			_self.showForm=false;
			setTimeout(function(){_self.showForm=true;},500);

			setTimeout(function(){_self.handleShowCaptchaFn();},1000);
			
		},
		handleShowCaptchaFn(){
			const _self=this;
			if(document.location.host=='azure-devops.io') _self.showCaptcha=false;
			else _self.showCaptcha=true;
		},
		async sendPricingQuote(){
			const _self=this;
			if(!_self.isCaptchaVerified && _self.showCaptcha){
				alert('Please verify the captcha');
				return;
			}
			let data=_self.data;
			data.demo=_self.demo;
			data.contact=_self.contact;
			_self.fn().showLoader(true);
			try{
				let str=_self.demo?'Demo':(_self.contact?'Contact':'Quote');
				let response=await _self.post('contact/requestQuote',data);
				if(response.data && response.data.Success){
					alert(`${str} requested successfull. We will get back to you ASAP!!`)
				}else{
					alert(`${str} request failed. Please send an email to ${_self.supportEmail}`);
				}
			}
			catch(ex){
				console.log(ex);
			}
			finally{
				_self.fn().showLoader(false);
				_self.resetForm();
			}
			
		}
	},
	components:{VueRecaptcha,[Select.name]: Select,[Option.name]: Option}
}

